"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.bmFormFieldStyles = exports.bmFormInputStyles = exports.bmFormSelectStyles = exports.bmFormSelectReadonlyStyles = exports.bmFormInputReadonlyStyles = exports.bmFormReadonlyStyle = exports.bmFormInputStyle = exports.bmLabelStyles = exports.bmBold = exports.bmFormLargeTitleStyle = exports.bmFormSmallTitleStyle = exports.bmFormDescriptionStyle = exports.bmFormLabelStyle = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@blue/element");

var _uiElements = require("@blue/ui-elements");

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t:host bm-select.bm-fe-select.bm-readonly {\n\t\t\tbackground: initial;\n\t\t}\n\t\t:host bm-select.bm-fe-select.bm-readonly::after {\n\t\t\tdisplay: none;\n\t\t}\n\t"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t:host input.bm-input.bm-fe-input[readonly] {\n\t\t\tfont-weight: 400;\n\t\t}\n\t"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host input.bm-input.bm-fe-input[readonly],\n\t:host bm-select.bm-fe-select.bm-readonly select {\n\t\tbackground: transparent;\n\t\tborder: none;\n\t\toutline: none;\n\t\tpadding: 0;\n\t\theight: initial;\n\t}\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host input.bm-input.bm-fe-input {\n\t\theight: 40px;\n\t\tmax-width: 270px;\n\t\tmin-width: 120px;\n\t\tbox-sizing: border-box;\n\t\tfont-weight: var(--bm-text-input-bold) !important;\n\t}\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host .bm-bold {\n\t\tfont-weight: bold;\n\t}\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host .bm-form-large-title {\n\t\tfont-size: 24px;\n\t\tfont-family: KnowledgeRegular, Arial, sans-serif;\n\t\tfont-weight: 400;\n\t}\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host .bm-form-small-title {\n\t\tfont-size: 22px;\n\t\tfont-family: KnowledgeRegular, Arial, sans-serif;\n\t\tfont-weight: 400;\n\t}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host .bm-form-description {\n\t\tfont-size: 16px;\n\t\tfont-family: Arial, sans-serif;\n\t\tfont-weight: 400;\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host .bm-form-label {\n\t\tfont-size: 14px;\n\t\tfont-family: 'Helvetica Neue', Arial, sans-serif;\n\t\tfont-weight: 400;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var bmFormLabelStyle = (0, _element.css)(_templateObject());
exports.bmFormLabelStyle = bmFormLabelStyle;
var bmFormDescriptionStyle = (0, _element.css)(_templateObject2());
exports.bmFormDescriptionStyle = bmFormDescriptionStyle;
var bmFormSmallTitleStyle = (0, _element.css)(_templateObject3());
exports.bmFormSmallTitleStyle = bmFormSmallTitleStyle;
var bmFormLargeTitleStyle = (0, _element.css)(_templateObject4());
exports.bmFormLargeTitleStyle = bmFormLargeTitleStyle;
var bmBold = (0, _element.css)(_templateObject5());
exports.bmBold = bmBold;
var bmLabelStyles = [bmFormLabelStyle, bmFormDescriptionStyle, bmFormSmallTitleStyle, bmFormLargeTitleStyle, bmBold];
exports.bmLabelStyles = bmLabelStyles;
var bmFormInputStyle = (0, _element.css)(_templateObject6());
exports.bmFormInputStyle = bmFormInputStyle;
var bmFormReadonlyStyle = (0, _element.css)(_templateObject7());
exports.bmFormReadonlyStyle = bmFormReadonlyStyle;
var bmFormInputReadonlyStyles = [bmFormReadonlyStyle, (0, _element.css)(_templateObject8())];
exports.bmFormInputReadonlyStyles = bmFormInputReadonlyStyles;
var bmFormSelectReadonlyStyles = [bmFormReadonlyStyle, (0, _element.css)(_templateObject9())];
exports.bmFormSelectReadonlyStyles = bmFormSelectReadonlyStyles;
var bmFormSelectStyles = [bmFormReadonlyStyle, bmFormSelectReadonlyStyles];
exports.bmFormSelectStyles = bmFormSelectStyles;
var bmFormInputStyles = [_uiElements.bmInputStyle, bmFormInputStyle, bmFormInputReadonlyStyles];
exports.bmFormInputStyles = bmFormInputStyles;
var bmFormFieldStyles = [bmFormInputStyles, bmFormSelectStyles];
exports.bmFormFieldStyles = bmFormFieldStyles;
